import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormService} from "@core/shared/services/form.service";
import {Offer} from "@core/shared/models/offer";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {OfferPeriodService} from "@core/shared/services/offer/offer-period.service";
import {Moment} from "moment";
import {DATE_FORMAT} from "@app/data";
import {OfferPeriodDeleteConfiguration} from "@core/shared/models/offer/offer-period/offer-period-delete";

@Component({
    selector: 'app-core-offer-period-delete',
    templateUrl: './offer-period-delete.component.html',
    styleUrls: ['./offer-period-delete.component.scss'],
    providers: [
        FormService
    ],
    standalone: false
})
export class OfferPeriodDeleteComponent implements OnInit {

    @Input() offer: Offer;

    @Input() configuration: OfferPeriodDeleteConfiguration;

    @Output() delete: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _offerPeriodService: OfferPeriodService,
        public formService: FormService
    ) {
    }

    ngOnInit(): void {

        this._initForm();
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({
            dateStart: ['', [Validators.required]],
            dateEnd: ['', [Validators.required]]
        });

        this.formService.submitCallback = (): void => {

            const data: object = Object.assign(this.form.value, {
                dateStart: (this.form.get('dateStart').value as Moment).format(DATE_FORMAT),
                dateEnd: (this.form.get('dateEnd').value as Moment).format(DATE_FORMAT)
            });

            this._offerPeriodService.deleteItemAPI(this.offer.id, data).subscribe((): void => {

                this.delete.emit();
            });
        };
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }
}
